import { render, staticRenderFns } from "./Shifts1Dropdown.vue?vue&type=template&id=8f1ef220&scoped=true&"
import script from "./Shifts1Dropdown.vue?vue&type=script&lang=js&"
export * from "./Shifts1Dropdown.vue?vue&type=script&lang=js&"
import style0 from "./Shifts1Dropdown.vue?vue&type=style&index=0&id=8f1ef220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1ef220",
  null
  
)

export default component.exports